import React, { ReactNode } from "react"
import styles from "./Button.module.css"

interface ButtonProps {
  type: "button" | "link"
  href?: string
  children: ReactNode
  onClick?: any
}

const Button = ({ type, href, children, onClick }: ButtonProps) => {
  return type === "button" ? (
    <button className={styles.button} onClick={onClick}>
      {children}
    </button>
  ) : (
    <a href={href} target="_blank" className={styles.button} rel="noreferrer">
      {children}
    </a>
  )
}

export default Button
